import {Bullet} from 'commons/models';

export const data: Array<Bullet> = [
    {
        desc: 'Para continuar es necesario que aceptes:',
        items: [
            {
                item: 1,
                sections: [
                    {
                        value: 'Recibo de pago por servicios domiciliarios, con una antig\u00FCedad no mayor a tres meses a su fecha de emisi\u00F3n como:',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 2,
                sections: [
                    {
                        value: 'Suministro de energ\u00EDa electrica.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 3,
                sections: [
                    {
                        value: 'Telefon\u00EDa.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 4,
                sections: [
                    {
                        value: 'Gas Natural.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 5,
                sections: [
                    {
                        value: 'Impuesto predial o de derechos por suministro de agua o estados de cuenta bancarios.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 6,
                sections: [
                    {
                        value: 'Contrato de arrendamiento vigente a la fecha de presentaci\u00F3n por el cliente.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 7,
                sections: [
                    {
                        value: 'Comprobante de inscripci\u00F3n ante el Registro Federal de Contribuyentes.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
        ],
    },
];
